import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B1D16] text-[#FAF9F6] relative grain">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div className="space-y-4">
        <Logo dark />
        <p className="text-sm text-[#FAF9F6]/60 leading-relaxed max-w-xs">
          A better coffee machine for workplaces, gyms, student halls and leisure centres. 22p of every cup goes to a charity the host chooses.
        </p>
        <p className="text-xs font-mono-brand uppercase tracking-[0.28em] text-[#93A56B]">Good coffee. Great causes.</p>
        <a href="mailto:hello@giveandgrind.com" data-testid="footer-email"
          className="inline-block text-sm font-semibold text-[#34D399] hover:text-[#D97706] transition-colors">
          hello@giveandgrind.com
        </a>
        <a href="tel:+447706552322" data-testid="footer-phone"
          className="block mt-2 text-sm font-semibold text-[#34D399] hover:text-[#D97706] transition-colors">
          +44 7706 552322
        </a>
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#34D399] mb-4">Explore</p>
        <div className="flex flex-col gap-2.5 text-sm">
          <a href="/#how-it-works" className="text-[#FAF9F6]/70 hover:text-[#FAF9F6] transition-colors">How it works</a>
          <a href="/#model" className="text-[#FAF9F6]/70 hover:text-[#FAF9F6] transition-colors">The 22p model</a>
          <a href="/ladder" className="text-[#FAF9F6]/70 hover:text-[#FAF9F6] transition-colors">The Bean Ladder</a>
          <a href="/#faq" className="text-[#FAF9F6]/70 hover:text-[#FAF9F6] transition-colors">FAQ</a>
          <a href="/#enquire" className="text-[#FAF9F6]/70 hover:text-[#FAF9F6] transition-colors">Host a machine</a>
        </div>
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#34D399] mb-4">Charity partners</p>
        <div className="flex flex-wrap gap-2">
          {["Shelter UK", "Macmillan", "Mind UK", "Woodland Trust", "Trussell Trust"].map((c) => (
            <span key={c} className="text-xs font-semibold px-3 py-1.5 rounded-full border border-white/15 text-[#FAF9F6]/70">
              {c}
            </span>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row gap-3 justify-between text-xs text-[#FAF9F6]/45">
        <p>Give &amp; Grind Ltd — registered in England &amp; Wales (Company No. 15984321). Registered address: 120 Clifton Street, London EC2A 4HB.</p>
        <p>© 2026 Give &amp; Grind Ltd</p>
      </div>
    </div>
  </footer>
);
